export default __webpack_public_path__ + "static/media/drone.c4012c34.mp4";